import Auth0Service from "../auth0/Auth0Service";
import IAuth0User from "../auth0/IAuth0User";
import _ from "lodash";

export default class Usuario {
	// Deprecated - kept for backward compatibility, will be removed
	static Papel_UserCompany = "user_company";

	public Info: IAuth0User | null;
	public EhLogado: boolean = false;
	private auth0Service: Auth0Service | null = null;

	public constructor() {
		this.EhLogado = false;
		this.Info = null;
	}

	public setAuth0Service(auth0Service: Auth0Service): void {
		this.auth0Service = auth0Service;
	}

	public async VerificaLogado(): Promise<IAuth0User> {
		return new Promise((fnDone: (user: IAuth0User) => void, fnError) => {
			if (!this.auth0Service) {
				fnError(new Error("Auth0 service not initialized"));
				return;
			}

			if (this.auth0Service.isLoading()) {
				// Wait for Auth0 to finish loading
				setTimeout(() => {
					this.VerificaLogado().then(fnDone).catch(fnError);
				}, 100);
				return;
			}

			if (!this.auth0Service.isAuthenticated()) {
				fnError(new Error("User not authenticated"));
				return;
			}

			const user = this.auth0Service.getUser();
			if (!user) {
				fnError(new Error("User data not available"));
				return;
			}

			this.Info = user;
			this.EhLogado = true;
			fnDone(user);
		});
	}

	public static tokenInvalidoLogout(): void {
		// Remove any stored tokens
		localStorage.removeItem("access_token");
		localStorage.removeItem("arteh-api-token");

		// Redirect to login
		Usuario.Login();
	}

	public static Login(_errorCode: string = ""): void {
		// Auth0 login will be handled by the Auth0Provider
		// This method is now just a placeholder for compatibility
	}

	public static Logout(): void {
		// Auth0 logout will be handled by the Auth0Provider
		// This method is now just a placeholder for compatibility
	}

	public ehPapel(papel: string): boolean {
		if (!_.isNull(this.Info)) {
			// Check all possible role locations (handle double slash issue)
			const namespacedRoles =
				this.Info["https://arteh.com.au/roles"] || [];
			const namespacedRolesDoubleSlash =
				this.Info["https://arteh.com.au//roles"] || [];
			const legacyRoles = this.Info.roles || [];
			const allRoles = [
				...namespacedRoles,
				...namespacedRolesDoubleSlash,
				...legacyRoles,
			];
			return _.includes(allRoles, papel);
		}
		return false;
	}

	public async getAccessToken(): Promise<string | undefined> {
		if (!this.auth0Service) {
			return undefined;
		}
		return await this.auth0Service.getAccessToken();
	}

	public async getIdToken(): Promise<string | undefined> {
		if (!this.auth0Service) {
			return undefined;
		}
		return await this.auth0Service.getIdToken();
	}
}

export type { IAuth0User };
